module.exports = __webpack_public_path__ + "zvetseni-prsou_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_1_after.jpg
// module id = 1311
// module chunks = 0